export enum AlertStatus {
  AMBER = 'AMBER',
  RED = 'RED'
}
